export var MenuContentTestIds = /*#__PURE__*/function (MenuContentTestIds) {
  MenuContentTestIds["ROOT"] = "menu-content-root";
  MenuContentTestIds["HEADING"] = "menu-content-heading";
  MenuContentTestIds["TEXT"] = "menu-content-text";
  MenuContentTestIds["AVATAR"] = "menu-content-avatar";
  MenuContentTestIds["USER_EMAIL"] = "menu-content-user-email";
  MenuContentTestIds["USER_PHONE"] = "menu-content-user-phone";
  MenuContentTestIds["USER_NAME"] = "menu-content-user-name";
  MenuContentTestIds["BENEFITS_LINK"] = "menu-content-benefits-link";
  return MenuContentTestIds;
}({});